import { render } from "./AddProvider.vue?vue&type=template&id=5bc2fc24&ts=true"
import script from "./AddProvider.vue?vue&type=script&lang=ts"
export * from "./AddProvider.vue?vue&type=script&lang=ts"

import "./AddProvider.vue?vue&type=style&index=0&id=5bc2fc24&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__